import { render, staticRenderFns } from "./CusApplet.vue?vue&type=template&id=787568ea&scoped=true"
import script from "./CusApplet.vue?vue&type=script&lang=js"
export * from "./CusApplet.vue?vue&type=script&lang=js"
import style0 from "./CusApplet.vue?vue&type=style&index=0&id=787568ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787568ea",
  null
  
)

export default component.exports